import ActionButton from "components/common/ActionButton";
import { useState } from "react";
import { Spinner as BSpinner } from 'react-bootstrap';
import DebounceInputFiled from "../DebounceInputField";
import QualitativeEditModal from "../QualitativeEditModal";

const ConceptsActionsButton = ({ unCheckAll, checkAll, totalChecked, sortData, handleCheckSimilarityIndex, reloadData, handleDelete, handleTaging, handleEdit, handleMerge }) => {

    const [actions, setActions] = useState({
        deleting: false,
        editing: false,
        tagging: false,
        merging: false,
        unflagging: false,
        similarity_checking: false,
    });
    const [showEditModal, setShowEditModal] = useState(false);
    const [showMergeModal, setShowMergeModal] = useState(false);
    const [showTagModal, setShowTagModal] = useState(false);

    const handleDeleteClick = async () => {
        setActions({ ...actions, deleting: true });
        await handleDelete();
        setActions({ ...actions, deleting: false });
    }

    const handleEditClick = () => {
        setActions({ ...actions, editing: true });
        setShowEditModal(true);
        setActions({ ...actions, editing: false });
    }

    const handleMergeClick = async (concept_name = '') => {
        setActions({ ...actions, merging: true });
        await handleMerge(concept_name);
        setActions({ ...actions, merging: false });
    }

    const handleTagClick = async (tag_name) => {
        setActions({ ...actions, tagging: true });
        await handleTaging(tag_name);
        setActions({ ...actions, tagging: false });
    }

    const handleUnFlagClick = async () => {
        setActions({...actions, unflagging: true });
        await handleTaging('');
        setActions({...actions, unflagging: false });
    }

    const handleSimilarityCheckClick = async () => {
        setActions({...actions, similarity_checking: true });
        await handleCheckSimilarityIndex();
        setActions({...actions, similarity_checking: false });
    }

    return (
        <>
            {
                showTagModal &&
                <QualitativeEditModal
                    show={showTagModal}
                    onHide={() => setShowTagModal(false)}
                    title='Tag Umbrella Concepts'
                    buttonText="Tag"
                    buttonLoadingText="Tagging..."
                    textFiledLabel='Tag'
                    reloadData={handleTagClick}
                />
            }
            {
                showMergeModal &&
                <QualitativeEditModal
                    show={showMergeModal}
                    onHide={() => setShowMergeModal(false)}
                    title='Merge Concepts'
                    buttonText="Merge"
                    buttonLoadingText="Merging..."
                    textFiledLabel='Concept'
                    reloadData={handleMergeClick}
                />
            }
            {
                showEditModal &&
                <QualitativeEditModal
                    show={showEditModal}
                    onHide={() => setShowEditModal(false)}
                    title='Edit Concepts'
                    buttonText="Update"
                    buttonLoadingText="Updating..."
                    textFiledLabel='Concept'
                    reloadData={handleEdit}
                />
            }
            <div className="d-flex justify-content-between w-100">
                <div>
                    <ActionButton
                        className="p-3 m-1"
                        variant="dark"
                        onClick={() => unCheckAll()}
                    >
                        Uncheck All
                    </ActionButton>
                    <ActionButton
                        className="p-3 m-1"
                        variant="warning"
                        onClick={() => checkAll()}
                    >
                        Check All - Checked({totalChecked()})
                    </ActionButton>
                    <ActionButton
                        className="p-3 m-1"
                        variant="secondary"
                        onClick={() => sortData('frequency', 'desc')}
                        disabled={actions.sorting_freq}
                    >
                        {
                            actions.sorting_freq ? <BSpinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            /> : "Sort by Frequency"
                        }
                    </ActionButton>
                    <ActionButton
                        className="p-3 m-1"
                        variant="info"
                        onClick={() => sortData('tag_type')}
                        disabled={actions.sorting_flag}
                    >
                        {
                            actions.sorting_flag ? <BSpinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            /> : "Sort by Flag"
                        }
                    </ActionButton>
                    <ActionButton
                        className="p-3 m-1"
                        variant="primary"
                        onClick={() => sortData('umbrella_concept')}
                        disabled={actions.sorting_text}
                    >
                        {
                            actions.sorting_text ? <BSpinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            /> : "Sort Alphabatically"
                        }
                    </ActionButton>
                    <ActionButton
                        className="p-3 m-1"
                        variant="warning"
                        onClick={() => {
                            handleSimilarityCheckClick();
                        }}
                        disabled={actions.similarity_checking}
                    >
                        {
                            actions.similarity_checking ? <BSpinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            /> : "Check Similarity"
                        }
                    </ActionButton>
                    <DebounceInputFiled reloadData={(value) => reloadData(value)} />
                </div>
                <div>
                    <ActionButton
                        className="p-3 m-1"
                        variant='success'
                        onClick={() => {
                            handleEditClick();
                        }}
                        disabled={actions.editing}
                    >
                        {
                            actions.editing ? <BSpinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            /> : "Edit Selected"
                        }
                    </ActionButton>
                    <ActionButton
                        className="p-3 m-1"
                        variant='dark'
                        onClick={() => setShowMergeModal(true)}
                        disabled={actions.merging}
                    >
                        {
                            actions.merging ? <BSpinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            /> : "Merge Selected"
                        }
                    </ActionButton>
                    <ActionButton
                        className="p-3 m-1"
                        variant="danger"
                        onClick={() => handleDeleteClick()}
                        disabled={actions.deleting}
                    >
                        {
                            actions.deleting ? <BSpinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            /> : "Delete Selected"
                        }
                    </ActionButton>
                    <ActionButton
                        className="p-3 m-1"
                        variant="info"
                        onClick={() => {
                            setShowTagModal(true);
                        }}
                        disabled={actions.tagging}
                    >
                        {
                            actions.flaging ? <BSpinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            /> : "Flag Selected"
                        }
                    </ActionButton>
                    <ActionButton
                        className="p-3 m-1"
                        variant="dark"
                        disabled={actions.tagging}
                        onClick={() => handleUnFlagClick()}
                    >
                        {
                            actions.unflagging ? <BSpinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            /> : "UnFlag Selected"
                        }
                    </ActionButton>
                </div>
            </div>
        </>
    );
}

ConceptsActionsButton.defaultProps = {
    unCheckAll: () => { },
    checkAll: () => { },
    sortData: () => { },
    handleCheckSimilarityIndex: () => { },
    reloadData: () => { },
    handleDelete: () => { },
    handleTaging: () => { },
    handleEdit: () => { },
};

export default ConceptsActionsButton;